module.exports = __webpack_public_path__ + "static/media/seo-monitoring.21b74723.svg";